import React from "react";
import { Link } from "react-router-dom";
import { verifyPermission } from "helpers/permission";

const TypeCompteRow = ({ type, index, onDelete, t, userPermissions }) => {
  return (
    <tr key={index} role="row" className="odd">
      <td>{type.name?.fr}</td>
      <td>{type.description?.fr}</td>
      <td style={{ textAlign: "center" }}>
        {verifyPermission(userPermissions, "show-account-type") && (
          <Link
            to={`/settings/accounts/type/edit/${type.id}`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Modifier")}
          >
            <i className="la la-edit" />
          </Link>
        )}
        {verifyPermission(userPermissions, "destroy-account-type") && (
          <button
            onClick={() => onDelete(type.id, index)}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Supprimer")}
          >
            <i className="la la-trash" />
          </button>
        )}
      </td>
    </tr>
  );
};

export default React.memo(TypeCompteRow);
